import swall from 'sweetalert'
import storage from '../../commons/config/storage.config'
import store from '../../store'

export default class ErrorService extends Error {
  constructor (error) {
    super(error)
    if (!error?.response) {
      store.commit('loader/startPercentage', { percentage: 0 })
      return
    }
    this.name = 'Error: '
    this.error = error.request.response === 'Invalid token' ? { status: 401, message: 'Sesi anda telah berakhir' } : error.request.response ? JSON.parse(error.request.response) : error || { status: 500, message: 'Ternadi Kesalahan' }
    // this.error = error.request.response === '' ? { status: 401, message: 'Sesi anda telah berakhir' } : error.request.response ? JSON.parse(error.request.response) : error
  }

  showError () {
    const message = {
      title: this.error.status === 500 ? 'Terjadi Kesalahan' : this.error.status ? 'Perhatian' : 'Jaringan Bermasalah',
      icon: this.error.status === 500 ? 'error' : this.error.success ? 'success' : this.error.status ? 'warning' : 'error',
      text: this.error.status === 500 ? this.error.message : this.error.status ? this.error.message : this.error.message.charAt(0).toUpperCase() + this.error.message.slice(1)
      // text: this.error.status === 500 ? 'System Exception' : this.error.status ? this.error.message : this.error.message.charAt(0).toUpperCase() + this.error.message.slice(1)
    }

    if (this.error.status === 403 || this.error.status === 401) {
      swall(message).then((result) => {
        if (result) {
          storage.clearSession()
          location.replace('/home')
        }
      })
    } else {
      swall(message).then((result) => {
        if (result) {
        }
      })
    }
  }

  // showErrorUpload () {
  //   const message = {
  //     title: 'Perhatian',
  //     icon: 'warning',
  //     text: errorparser(this.error.message)
  //   }
  //
  //   swall(message)
  // }
}
